import { lazyForPaint } from 'react-loosely-lazy';
const LasyInstallationTab = lazyForPaint(() => import( /* webpackPrefetch: true, webpackChunkName: "chunk-installation-tabv2" */'./InstallationTab').then(module => module.default));
export default LasyInstallationTab;